import * as React from 'react';

const LogoGmailSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.1 16.5l5-5 1.8 1.9 1.9-1.9 5 5v2.4H5.1v-2.4zm9.3-5.4l4.5-4.4v8.9l-4.5-4.5zM5.1 6.3L9.7 11l-4.6 4.6V6.3zm3-1.2h8.4L12 9.3 8.1 5.1zM2 4.5v15h20v-15H2z"
        />
    </svg>
);

LogoGmailSvg.displayName = 'LogoGmailSvg';
export default LogoGmailSvg;
